<template>
  <v-container fluid class="pa-0">
    <div class="d-flex justify-space-between align-center flex-wrap">
      <div>
        <h2 class="subheading grey--text">Integrantes</h2>
        <p class="grey--text text--darken-1 mb-0">Periodo actual: {{ periodo.nombre ? periodo.nombre.replace('Mesa Directiva ', '') : 'Cargando...' }} · {{ miembros.length }} integrantes registrados</p>
      </div>
      <div>
        <v-btn color="primary" @click="openNew()">
          <v-icon left>mdi-plus</v-icon>
          Agregar integrante
        </v-btn>
      </div>
    </div>

    <v-card class="elevation-2 mt-4">
      <v-card-title>
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          label="Buscar integrante"
          outlined
          dense
          hide-details
          clearable
          style="max-width: 320px;"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="miembros"
        :search="search"
        :loading="loading"
        loading-text="Cargando integrantes..."
        :footer-props="{
          itemsPerPageOptions: [{text: '5', value: 5}, {text: '10', value: 10}, {text: 'Todos', value: -1}],
          itemsPerPageText: 'Filas por página'
        }"
        :no-data-text="'No hay integrantes registrados'"
        class="elevation-0"
      >
        <template v-slot:item.name="{ item }">
          <div class="d-flex align-center">
            <v-avatar size="34" color="green lighten-4" class="mr-3">
              <span class="green--text text--darken-3 caption font-weight-bold">{{ initials(item.name) }}</span>
            </v-avatar>
            <div>
              <div class="font-weight-medium">{{ item.name }}</div>
              <div class="caption grey--text">{{ item.email }}</div>
            </div>
          </div>
        </template>
        <template v-slot:item.cargo="{ item }">
          <v-chip small outlined color="green darken-3">{{ item.cargo }}</v-chip>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip small :color="estadoColor(item.status)" text-color="white">{{ item.status }}</v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" v-on="on" @click="viewMember(item)">mdi-eye-outline</v-icon>
            </template>
            <span>Ver</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" v-on="on" @click="editMember(item)">mdi-pencil</v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small v-on="on" @click="toggleStatus(item)">mdi-toggle-switch-outline</v-icon>
            </template>
            <span>Activar / desactivar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialog" persistent scrollable max-width="520">
      <v-form @submit.prevent="save()">
        <v-card class="elevation-5">
          <v-toolbar dark color="primary">
            <v-toolbar-title>{{ editing ? 'Editar integrante' : 'Agregar integrante' }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text class="pt-5">
            <v-autocomplete
              v-if="!editing"
              v-model="form.resident"
              :items="residentesDisponibles"
              item-text="text"
              item-value="value"
              label="* Residente"
              prepend-icon="mdi-account-search-outline"
              outlined
              dense
              clearable
              :loading="loadingResidentes"
              no-data-text="No se encontraron residentes"
              @change="onResidentSelected"
            ></v-autocomplete>
            <v-select
              v-model="form.position"
              :items="cargosDisponibles"
              item-text="text"
              item-value="value"
              label="* Cargo"
              prepend-icon="mdi-shield-account-outline"
              outlined
              dense
              :loading="cargosDisponibles.length === 0"
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-title v-if="cargosDisponibles.length === 0">
                    No hay cargos disponibles. Debe crear posiciones primero.
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-select>
            <v-select v-model="form.status" :items="[{ value: 'active', text: 'Activo' }, { value: 'inactive', text: 'Inactivo' }]" item-text="text" item-value="value" label="Estado" prepend-icon="mdi-checkbox-marked-circle-outline" outlined dense></v-select>
          </v-card-text>
          <v-card-actions>
            <v-btn color="grey darken-1" text @click="dialog = false">Cerrar</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit">{{ editing ? 'Guardar cambios' : 'Agregar' }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="viewDialog" scrollable max-width="420">
      <v-card v-if="selected">
        <v-toolbar dark color="primary" flat dense>
          <v-toolbar-title>{{ selected.name }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon small @click="viewDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-list dense>
          <v-list-item><v-list-item-icon><v-icon>mdi-shield-account-outline</v-icon></v-list-item-icon><v-list-item-content>{{ selected.cargo }}</v-list-item-content></v-list-item>
          <v-list-item><v-list-item-icon><v-icon>mdi-email-outline</v-icon></v-list-item-icon><v-list-item-content>{{ selected.email }}</v-list-item-content></v-list-item>
          <v-list-item><v-list-item-icon><v-icon>mdi-phone-outline</v-icon></v-list-item-icon><v-list-item-content>{{ selected.phone }}</v-list-item-content></v-list-item>
          <v-list-item><v-list-item-icon><v-icon>mdi-calendar-range</v-icon></v-list-item-icon><v-list-item-content>Periodo {{ selected.periodo }}</v-list-item-content></v-list-item>
        </v-list>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Configuración Inicial -->
    <v-dialog v-model="setupDialog" persistent scrollable max-width="600">
      <v-card class="elevation-5">
        <v-toolbar dark color="primary">
          <v-toolbar-title>Configurar Mesa Directiva</v-toolbar-title>
        </v-toolbar>

        <!-- Paso 1: Crear Período -->
        <v-card-text v-if="setupStep === 'period'" class="pt-5">
          <div class="mb-4">
            <h3>Paso 1: Crear Período</h3>
            <p class="grey--text">Crea el período para la mesa directiva actual</p>
          </div>
          <v-text-field v-model="periodForm.name" label="* Nombre del período" placeholder="Ej: 2026 - 2027" prepend-icon="mdi-text" outlined dense class="mb-3"></v-text-field>
          <v-text-field v-model="periodForm.start_date" label="* Fecha de inicio" type="date" prepend-icon="mdi-calendar-start" outlined dense class="mb-3"></v-text-field>
          <v-text-field v-model="periodForm.end_date" label="* Fecha de fin" type="date" prepend-icon="mdi-calendar-end" outlined dense></v-text-field>
        </v-card-text>

        <!-- Paso 2: Crear Posiciones -->
        <v-card-text v-if="setupStep === 'positions'" class="pt-5">
          <div class="mb-4 d-flex justify-space-between align-center">
            <div>
              <h3>Paso 2: Crear Posiciones</h3>
              <p class="grey--text mb-0">Selecciona los cargos que quieres crear</p>
            </div>
            <v-btn text small color="primary" @click="toggleSelectAllPositions()">
              {{ selectedPositions.length === defaultPositions.length ? 'Ninguno' : 'Todos' }}
            </v-btn>
          </div>
          <v-list dense>
            <v-list-item v-for="(pos, idx) in defaultPositions" :key="idx">
              <v-list-item-action>
                <v-checkbox
                  v-model="selectedPositions"
                  :value="pos.name"
                  :disabled="createdPositions.includes(pos.display_name)"
                  hide-details
                ></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ pos.display_name }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon v-if="createdPositions.includes(pos.display_name)">
                <v-icon color="green">mdi-check-circle</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-card-text>

        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn v-if="setupStep === 'period'" color="primary" @click="createPeriodAndPositions()" :loading="setupLoading">
            Siguiente
          </v-btn>
          <v-btn v-if="setupStep === 'positions'" color="primary" @click="createAllPositions()" :loading="setupLoading" :disabled="selectedPositions.length === 0">
            Crear {{ selectedPositions.length }} {{ selectedPositions.length === 1 ? 'cargo' : 'cargos' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import mesaDirectivaService from '@/services/mesaDirectivaService'
import residencesService from '@/services/residencesService'
import { estadoColor, initials } from './mesaDirectivaMockData'

export default {
  name: 'MesaDirectivaIntegrantes',
  data () {
    return {
      miembros: [],
      periodo: {},
      cargosDisponibles: [],
      posiciones: [],
      residentesDisponibles: [],
      residentesRaw: [],
      loadingResidentes: false,
      search: '',
      dialog: false,
      viewDialog: false,
      setupDialog: false,
      setupStep: 'period',
      editing: false,
      selected: null,
      form: this.emptyForm(),
      periodForm: { name: '', start_date: '', end_date: '' },
      positionForm: { display_name: '' },
      loading: false,
      setupLoading: false,
      defaultPositions: [
        { name: 'president', display_name: 'Presidente' },
        { name: 'vice_president', display_name: 'Vicepresidente' },
        { name: 'secretary', display_name: 'Secretario' },
        { name: 'treasurer', display_name: 'Tesorero' },
        { name: 'vocal', display_name: 'Vocal' },
        { name: 'admin', display_name: 'Administrador' }
      ],
      selectedPositions: ['president', 'vice_president', 'secretary', 'treasurer', 'vocal', 'admin'],
      createdPositions: [],
      headers: [
        { text: 'Integrante', value: 'name' },
        { text: 'Cargo', value: 'cargo' },
        { text: 'Teléfono', value: 'phone' },
        { text: 'Periodo', value: 'periodo' },
        { text: 'Estado', value: 'status' },
        { text: '', value: 'actions', sortable: false, align: 'end' }
      ]
    }
  },
  async mounted () {
    await this.loadData()
  },
  methods: {
    estadoColor,
    initials,
    emptyForm () {
      return { id: null, name: '', position: '', resident: '', email: '', phone: '', status: 'active' }
    },
    async loadData () {
      this.loading = true
      try {
        // Intentar obtener período primero
        let period
        try {
          period = await mesaDirectivaService.getCurrentPeriod()
        } catch (error) {
          // Si no hay período, mostrar setup dialog en paso 1
          console.log('No active period found, showing setup dialog:', error.message)
          this.setupDialog = true
          this.setupStep = 'period'
          return
        }

        // Si hay período, obtener posiciones
        let positions
        try {
          positions = await mesaDirectivaService.getAvailablePositions()
        } catch (error) {
          console.warn('Error obtaining positions:', error.message)
          positions = []
        }

        // Si no hay posiciones, mostrar setup dialog en paso 2
        if (!positions || positions.length === 0) {
          console.log('No positions found, showing setup dialog for position creation')
          this.setupDialog = true
          this.setupStep = 'positions'
          return
        }

        // Si hay período y posiciones, cargar todo normalmente
        const members = await mesaDirectivaService.getMembers()

        this.miembros = members.map(m => ({
          ...m,
          cargo: m.position_name,
          periodo: m.period_name,
          status: m.status === 'active' ? 'Activo' : 'Inactivo'
        }))

        this.periodo = {
          nombre: `Mesa Directiva ${period.name}`,
          inicio: period.start_date,
          fin: period.end_date,
          estado: period.is_active ? 'Activa' : 'Inactiva'
        }

        this.posiciones = positions
        this.cargosDisponibles = positions.map(p => ({ value: p.id, text: p.display_name }))
      } catch (error) {
        this.$store.commit('snackbar_change_color', 'error')
        this.$store.commit('snackbar_change_message', error.message || 'Error al cargar datos')
        this.$store.commit('snackbar_activate_true')
      } finally {
        this.loading = false
      }
    },
    async createPeriodAndPositions () {
      if (!this.periodForm.name || !this.periodForm.start_date || !this.periodForm.end_date) {
        this.$store.commit('snackbar_change_color', 'error')
        this.$store.commit('snackbar_change_message', 'Todos los campos del período son obligatorios')
        this.$store.commit('snackbar_activate_true')
        return
      }

      this.setupLoading = true
      try {
        // Crear período
        await mesaDirectivaService.createPeriod({
          name: this.periodForm.name,
          start_date: this.periodForm.start_date,
          end_date: this.periodForm.end_date,
          is_active: true
        })

        this.$store.commit('snackbar_change_color', 'success')
        this.$store.commit('snackbar_change_message', 'Período creado correctamente')
        this.$store.commit('snackbar_activate_true')
        this.setupStep = 'positions'
      } catch (error) {
        this.$store.commit('snackbar_change_color', 'error')
        this.$store.commit('snackbar_change_message', error.message)
        this.$store.commit('snackbar_activate_true')
      } finally {
        this.setupLoading = false
      }
    },
    toggleSelectAllPositions () {
      if (this.selectedPositions.length === this.defaultPositions.length) {
        this.selectedPositions = []
      } else {
        this.selectedPositions = this.defaultPositions.map(p => p.name)
      }
    },
    async createAllPositions () {
      if (this.selectedPositions.length === 0) {
        this.$store.commit('snackbar_change_color', 'error')
        this.$store.commit('snackbar_change_message', 'Selecciona al menos un cargo para crear')
        this.$store.commit('snackbar_activate_true')
        return
      }

      this.setupLoading = true
      try {
        const positionsToCreate = this.defaultPositions.filter(pos => this.selectedPositions.includes(pos.name))

        for (const pos of positionsToCreate) {
          try {
            await mesaDirectivaService.createPosition({
              name: pos.name,
              display_name: pos.display_name,
              is_active: true
            })
            this.createdPositions.push(pos.display_name)
          } catch (error) {
            console.warn(`Error creando posición ${pos.display_name}:`, error.message)
          }
        }

        this.$store.commit('snackbar_change_color', 'success')
        this.$store.commit('snackbar_change_message', `${this.createdPositions.length} posiciones creadas correctamente`)
        this.$store.commit('snackbar_activate_true')

        this.setupDialog = false
        this.createdPositions = []

        await this.loadData()
      } catch (error) {
        this.$store.commit('snackbar_change_color', 'error')
        this.$store.commit('snackbar_change_message', error.message)
        this.$store.commit('snackbar_activate_true')
      } finally {
        this.setupLoading = false
      }
    },
    async loadResidentes () {
      this.loadingResidentes = true
      try {
        const residents = await residencesService.getAllResidents()
        this.residentesRaw = residents
        this.residentesDisponibles = residents.map(r => ({
          value: r.id,
          text: `${r.fullname} · ${r.address}`
        }))
      } catch (error) {
        this.$store.commit('snackbar_change_color', 'error')
        this.$store.commit('snackbar_change_message', 'Error al cargar la lista de residentes')
        this.$store.commit('snackbar_activate_true')
      } finally {
        this.loadingResidentes = false
      }
    },
    onResidentSelected (residentId) {
      const resident = this.residentesRaw.find(r => r.id === residentId)
      if (!resident) return

      this.form.name = resident.fullname || this.form.name
      if (resident.idUser) {
        this.form.email = resident.idUser.email || this.form.email
        this.form.phone = resident.idUser.cellNumber || this.form.phone
      }
    },
    async openNew () {
      this.editing = false
      this.form = this.emptyForm()

      // Asegurar que los cargos estén cargados
      if (this.cargosDisponibles.length === 0) {
        try {
          const positions = await mesaDirectivaService.getAvailablePositions()
          this.cargosDisponibles = positions.map(p => ({
            value: p.id,
            text: p.display_name
          }))
        } catch (error) {
          this.$store.commit('snackbar_change_color', 'error')
          this.$store.commit('snackbar_change_message', 'Error al cargar los cargos disponibles')
          this.$store.commit('snackbar_activate_true')
          return
        }
      }

      // Cargar residentes disponibles
      if (this.residentesDisponibles.length === 0) {
        await this.loadResidentes()
      }

      this.dialog = true
    },
    async editMember (item) {
      this.editing = true
      this.form = {
        id: item.id,
        name: item.name,
        position: item.position,
        resident: item.resident || '',
        email: item.email || '',
        phone: item.phone || '',
        status: item.status === 'Activo' ? 'active' : 'inactive'
      }

      // Asegurar que los cargos estén cargados
      if (this.cargosDisponibles.length === 0) {
        try {
          const positions = await mesaDirectivaService.getAvailablePositions()
          this.cargosDisponibles = positions.map(p => ({
            value: p.id,
            text: p.display_name
          }))
        } catch (error) {
          console.error('Error al cargar posiciones:', error.message)
        }
      }

      this.dialog = true
    },
    viewMember (item) {
      this.selected = item
      this.viewDialog = true
    },
    async toggleStatus (item) {
      try {
        const newStatus = item.status === 'Activo' ? 'inactive' : 'active'
        await mesaDirectivaService.updateMember(item.id, { status: newStatus })
        item.status = item.status === 'Activo' ? 'Inactivo' : 'Activo'
        this.$store.commit('snackbar_change_color', 'success')
        this.$store.commit('snackbar_change_message', `${item.name} ahora está ${item.status.toLowerCase()}`)
        this.$store.commit('snackbar_activate_true')
      } catch (error) {
        this.$store.commit('snackbar_change_color', 'error')
        this.$store.commit('snackbar_change_message', error.message)
        this.$store.commit('snackbar_activate_true')
      }
    },
    async save () {
      if (!this.form.name || !this.form.position) {
        this.$store.commit('snackbar_change_color', 'error')
        this.$store.commit('snackbar_change_message', 'Nombre y cargo son obligatorios')
        this.$store.commit('snackbar_activate_true')
        return
      }

      if (!this.editing && !this.form.resident) {
        this.$store.commit('snackbar_change_color', 'error')
        this.$store.commit('snackbar_change_message', 'Residente es obligatorio para crear un integrante')
        this.$store.commit('snackbar_activate_true')
        return
      }

      try {
        this.loading = true
        const payload = {
          name: this.form.name,
          position: this.form.position,
          email: this.form.email || null,
          phone: this.form.phone || null,
          status: this.form.status
        }

        if (this.form.resident) {
          payload.resident = this.form.resident
        }

        let response
        if (this.editing) {
          response = await mesaDirectivaService.updateMember(this.form.id, payload)
          const idx = this.miembros.findIndex(m => m.id === this.form.id)
          if (idx !== -1) {
            this.miembros[idx] = {
              ...response,
              cargo: response.position_name,
              periodo: response.period_name,
              status: response.status === 'active' ? 'Activo' : 'Inactivo'
            }
          }
          this.$store.commit('snackbar_change_message', 'Integrante actualizado correctamente')
        } else {
          response = await mesaDirectivaService.createMember(payload)
          this.miembros.push({
            ...response,
            cargo: response.position_name,
            periodo: response.period_name,
            status: response.status === 'active' ? 'Activo' : 'Inactivo'
          })
          this.$store.commit('snackbar_change_message', 'Integrante agregado correctamente')
        }

        this.$store.commit('snackbar_change_color', 'success')
        this.$store.commit('snackbar_activate_true')
        this.dialog = false
      } catch (error) {
        this.$store.commit('snackbar_change_color', 'error')
        this.$store.commit('snackbar_change_message', error.message)
        this.$store.commit('snackbar_activate_true')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
